import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { Subject } from 'rxjs';

/**
 * Servicio para traducir las etiquetas del MatPaginator a español.
 * Se provee en app.module.ts para reemplazar la clase por defecto.
 */
@Injectable()
export class MatPaginatorIntlEsp implements MatPaginatorIntl {
  changes = new Subject<void>();

  // --- ETIQUETAS TRADUCIDAS ---
  firstPageLabel = 'Primera página';
  itemsPerPageLabel = 'Resultados por página:';
  lastPageLabel = 'Última página';
  nextPageLabel = 'Siguiente página';
  previousPageLabel = 'Página anterior';

  /**
   * Traducción para el rango (Ej. "1 – 10 de 100")
   */
  getRangeLabel(page: number, pageSize: number, length: number): string {
    if (length === 0 || pageSize === 0) {
      // Traducido "0 of X"
      return `0 de ${length}`;
    }
    const total = Math.max(length, 0);
    const startIndex = page * pageSize;

    const endIndex = startIndex < total
      ? Math.min(startIndex + pageSize, total)
      : startIndex + pageSize;

    // Traducido "1 – 10 of 100"
    return `${startIndex + 1} – ${endIndex} de ${total}`;
  }
}
